import React from 'react';

const ContinentIcon = ({ className }) => (
    <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
    >
        <path
            d='M10 3.84271C9.79312 3.84271 9.58907 3.79457 9.404 3.70209L6.596 2.29809C6.41094 2.20561 6.20689 2.15747 6 2.15747M10 3.84271C10.2069 3.84271 10.4109 3.79457 10.596 3.70209L13.0353 2.48209C13.1371 2.43126 13.2501 2.4073 13.3637 2.41247C13.4773 2.41764 13.5876 2.45178 13.6843 2.51165C13.781 2.57151 13.8607 2.6551 13.916 2.75448C13.9713 2.85386 14.0002 2.96572 14 3.07943V11.5888C13.9999 11.7125 13.9654 11.8338 13.9003 11.9391C13.8352 12.0444 13.7421 12.1294 13.6313 12.1848L10.596 13.7028C10.4109 13.7952 10.2069 13.8434 10 13.8434M10 3.84271V13.8434M10 13.8434C9.79312 13.8434 9.58907 13.7952 9.404 13.7028L6.596 12.2988C6.41094 12.2063 6.20689 12.1581 6 12.1581M6 12.1581C5.79312 12.1581 5.58907 12.2063 5.404 12.2988L2.96467 13.5188C2.8629 13.5696 2.74982 13.5936 2.63617 13.5884C2.52253 13.5832 2.41211 13.549 2.31541 13.489C2.21872 13.4291 2.13898 13.3454 2.08377 13.2459C2.02856 13.1465 1.99972 13.0345 2 12.9208V4.41209C2.00007 4.28832 2.03459 4.167 2.0997 4.06174C2.16482 3.95648 2.25795 3.87142 2.36867 3.81609L5.404 2.29809C5.58907 2.20561 5.79312 2.15747 6 2.15747M6 12.1581V2.15747'
            stroke='#00225F'
            strokeWidth='1.25'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export { ContinentIcon };
